import { type Store } from 'redux';

import { type SelectableItem, selectableItemsSelector } from '@air/redux-selected-items';

import { type AirState } from '~/store/types';

/**
 * Calculates the rank (0-based index) of an item in the current selectable items list.
 * Returns undefined if no search is active or item is not found.
 */
export function calculateRankForItem(store: Store<AirState>, itemId: string): number | undefined {
  const selectableItems = selectableItemsSelector(store.getState());
  const foundIndex = selectableItems.findIndex((item) => item.id === itemId);

  return foundIndex >= 0 ? foundIndex : undefined;
}

/**
 * Calculates the rank for a single selected item.
 * Returns undefined if multiple items are selected, no search is active, or item not found.
 */
export function calculateRankForSingleSelection(
  store: Store<AirState>,
  selectedItems: SelectableItem[] | undefined,
): number | undefined {
  if (!selectedItems || selectedItems.length !== 1) {
    return undefined;
  }

  const item = selectedItems[0];

  return calculateRankForItem(store, item.id);
}
